module.exports = __webpack_public_path__ + "static/map-marker-9a9a376e21644be149f3f3c985340c22.png";